export interface OnboardingProfile {
  role: string | null | undefined;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
}

const CLIENT_ROLES = new Set(["client", "user"]);

/** Klijent treba onboarding kada mu nedostaje ime ili prezime. */
export function needsOnboarding(profile: OnboardingProfile): boolean {
  const role = profile.role ?? "client";
  if (!CLIENT_ROLES.has(role)) return false;
  const hasFirst = (profile.firstName ?? "").trim().length > 0;
  const hasLast = (profile.lastName ?? "").trim().length > 0;
  return !(hasFirst && hasLast);
}

export function splitFullNameForProfile(
  name: string,
): { firstName: string; lastName: string } | null {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return null;
  return {
    firstName: parts[0] ?? "",
    lastName: parts.slice(1).join(" "),
  };
}
